import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTopicsState } from "../store/topics/selectors";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getTopicsByTenantId } from "../store/topics/thunks";

export const useTenantTopics = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { topicsByTenants, loading } = useSelector(selectTopicsState);

  useEffect(() => {
    if (selectedTenantId && !topicsByTenants?.[selectedTenantId]) {
      dispatch(
        getTopicsByTenantId({
          tenant_id: selectedTenantId,
        })
      );
    }
  }, [selectedTenantId, topicsByTenants]);

  const topics = useMemo(() => {
    return topicsByTenants[selectedTenantId] || [];
  }, [topicsByTenants, selectedTenantId]);

  return { topics, loading, selectedTenantId };
};
